/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const VehicleDataService = {
    /**
     * 车辆搜索查询
     * @param {*} simNo 
     * @returns Promise 
     */
    'findVehicleSearchBySimNo': function (simNo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '06a51d55488a5d4846dc95623bf8155776751d47', simNo)
            : execute(concreteModuleName, `/Vehicle/findVehicleSearchBySimNo`, 'json', 'POST', { simNo });
    }, 
    /**
     * 根据车辆id找历史记录信息
     * @param {*} vehicleId 车辆id
     * @returns Promise 
     */
    'finHistoryByVehicleId': function (vehicleId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '191586bfb0f926bcfc8b4ea15078ffc7f6f08896', vehicleId)
            : execute(concreteModuleName, `/Vehicle/finHistoryByVehicleId`, 'json', 'POST', { vehicleId });
    }, 
    /**
     * 获取烘干塔今日工作详情
     * @param {*} id 
     * @param {*} time YYYY-MM-DD
     * @returns Promise 
     */
    'findDryingTowerTodayWorkDetails': function (id, time) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6dcca218a77739c4b384e20457e4a5cc78c035f1', {id, time})
            : execute(concreteModuleName, `/Vehicle/${id}/findDryingTowerTodayWorkDetails`, 'json', 'POST', { time });
    }, 
    /**
     * 获取烘干塔详情
     * @param {*} details 
     * @returns Promise 
     */
    'findDryingTowerDetails': function (details) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'e8a04525b5962bc6a60b3c8b84d055b3bac20c6c', details)
            : execute(concreteModuleName, `/Vehicle/findDryingTowerDetails`, 'json', 'POST', details);
    }, 
    /**
     * 根据车辆id找记录信息
     * @param {*} vehicleId 车辆id
     * @returns Promise 
     */
    'finHistoryByVehicleIdList': function (vehicleId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'e9daa9b87e2f4a566960049424c20e55d517d494', vehicleId)
            : execute(concreteModuleName, `/Vehicle/finHistoryByVehicleIdList`, 'json', 'POST', { vehicleId });
    }, 
    /**
     * 导出车辆管理表 - 用于导出车辆管理表，其中socialServer字段：传1表示查询农机车辆，传2表示查询社会化服务车辆
     * @param {*} driver 车主姓名
     * @param {*} plateNo 车牌号
     * @param {*} simNo 设备号
     * @param {*} name 合作社名
     * @param {*} socialServer 车辆平台  0、共享  1、农机平台 2、社会化服务
     * @returns Promise 
     */
    'exportVehicleListNoPage': function (driver, plateNo, simNo, name, socialServer) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '4e6f0c00d300a0416394139feb0432206b33bb50', {driver, plateNo, simNo, name, socialServer})
            : execute(concreteModuleName, `/Vehicle/exportVehicleListNoPage`, 'json', 'POST', { driver, plateNo, simNo, name, socialServer });
    }, 
    /**
     * 查询车辆转合作社历史记录
     * @param {*} vehicleId 
     * @returns Promise 
     */
    'selectHistoryInfo': function (vehicleId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'e8f3a77c40788cd63f4fd2877bfc153b4943c59b', vehicleId)
            : execute(concreteModuleName, `/Vehicle/selectHistoryInfo`, 'json', 'POST', { vehicleId });
    }, 
    /**
     * 保存或修改车辆管理信息 - 其中socialServer字段：传1表示农机车辆，传2表示社会化服务车辆
     * @param {*} vehiclePojo 
     * @returns Promise 
     */
    'saveOrUpdateVehicleData': function (vehiclePojo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '288f82adc55061400e061c1dd1ff370eb9354764', vehiclePojo)
            : execute(concreteModuleName, `/Vehicle/orUpdateVehicleData`, 'json', 'POST', vehiclePojo);
    }, 
    /**
     * 查询单条车辆信息 - 根据ID查询车辆信息
     * @param {*} entityId 车辆主键ID
     * @returns Promise 
     */
    'selectVehicleById': function (entityId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'fad68ddd975c5dbb97c9d938a717b6d79528e722', entityId)
            : execute(concreteModuleName, `/Vehicle/selectVehicleById`, 'json', 'POST', { entityId });
    }, 
    /**
     * 发送TTS播报
     * @param {*} entityId 车辆ID
     * @param {*} textContent 下发指令内容
     * @returns Promise 
     */
    'sendTTSContent': function (entityId, textContent) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'd11548d70bf20bdde3816ee9b990ee00ff7f5c1f', {entityId, textContent})
            : execute(concreteModuleName, `/Vehicle/sendTTSContent`, 'json', 'POST', { entityId, textContent });
    }, 
    /**
     * 逻辑删除车辆管理信息 - 根据ID逻辑删除车辆管理信息
     * @param {*} entityId 车辆主键ID
     * @returns Promise 
     */
    'deleteVehicleById': function (entityId) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '6eca596c81cff38eecb8a816547d1a39f28ebe4b', entityId)
            : execute(concreteModuleName, `/Vehicle/vehicleById`, 'json', 'DELETE', { entityId });
    }, 
    /**
     * 根据ID修改车辆状态 - 0解锁，1锁车
     * @param {*} entityId 车辆ID
     * @param {*} status 车辆状态
     * @returns Promise 
     */
    'modifyVehicleStatus': function (entityId, status) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '85b072662f8c15f3a4b9d39820246963fbba8449', {entityId, status})
            : execute(concreteModuleName, `/Vehicle/modifyVehicleStatus`, 'json', 'POST', { entityId, status });
    }, 
    /**
     * 获取烘干塔今日工作详情
     * @param {*} id 车辆id
     * @param {*} time YYYY-MM-DD
     * @returns Promise 
     */
    'detailDryingTowerTodayWorkDetails': function (id, time) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'de282bfbb36017cafae14986fa11365f71ea6c1a', {id, time})
            : execute(concreteModuleName, `/Vehicle/detailDryingTowerTodayWorkDetails`, 'json', 'POST', { id, time });
    }, 
    /**
     * 添加车辆转合作社历史记录
     * @param {*} historyPojo 
     * @returns Promise 
     */
    'addHistoryInfo': function (historyPojo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '958a78accfc3ba57eb55efdc007b620c89ce98f6', historyPojo)
            : execute(concreteModuleName, `/Vehicle/addHistoryInfo`, 'json', 'POST', historyPojo);
    }, 
    /**
     * 获取烘干塔总工作详情
     * @param {*} details 
     * @returns Promise 
     */
    'findDryingTowerTotalWeightDetails': function (details) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '4a712208fad3d2537cd930a75f68f02fe879adf8', details)
            : execute(concreteModuleName, `/Vehicle/findDryingTowerTotalWeightDetails`, 'json', 'POST', details);
    }, 
    /**
     * 车辆管理列表 - 获取车辆管理列表，其中socialServer字段：传1表示查询农机车辆，传2表示查询社会化服务车辆
     * @param {*} paramMap 查询车辆列表传入的参
     * @returns Promise 
     */
    'vehicleList': function (paramMap) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '9fd8156dc5923a49bb9a4c0f3ba02779a415fb42', paramMap)
            : execute(concreteModuleName, `/Vehicle/vehicleList`, 'json', 'POST', paramMap);
    }
}

export default VehicleDataService
